/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signinwithmagiclink4Inputs */

const zh_auth_signinwithmagiclink4 = /** @type {(inputs: Auth_Signinwithmagiclink4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用邮箱链接登录`)
};

const en_auth_signinwithmagiclink4 = /** @type {(inputs: Auth_Signinwithmagiclink4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with magic link`)
};

const es_auth_signinwithmagiclink4 = /** @type {(inputs: Auth_Signinwithmagiclink4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión con enlace mágico`)
};

/**
* | output |
* | --- |
* | "Sign in with magic link" |
*
* @param {Auth_Signinwithmagiclink4Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_signinwithmagiclink4 = /** @type {((inputs?: Auth_Signinwithmagiclink4Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signinwithmagiclink4Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_signinwithmagiclink4(inputs)
	if (locale === "en") return en_auth_signinwithmagiclink4(inputs)
	return es_auth_signinwithmagiclink4(inputs)
});
export { auth_signinwithmagiclink4 as "auth_signInWithMagicLink" }